"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMilkRunV2Module = createMilkRunV2Module;
exports.state = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _getters = require("./getters");

var _actions = require("./actions");

var _mutations = require("./mutations");

var state = {
  selectedTruck: null,
  planDateRange: [(0, _moment.default)(new Date()).subtract(1, 'days').format('YYYY-MM-DD'), (0, _moment.default)(new Date()).add(3, 'days').format('YYYY-MM-DD')],
  tableLoading: true,
  plan: {},
  anyChanges: false,
  isPlanExists: false,
  truckFilters: [],
  trucks: [],
  truckLoading: true,
  selectedProjects: [],
  selectedCustomers: [],
  selectedTrucks: []
};
exports.state = state;
var namespaced = true;
var MilkRunV2Module = {
  namespaced: namespaced,
  state: state,
  getters: _getters.getters,
  actions: _actions.actions,
  mutations: _mutations.mutations
};

function createMilkRunV2Module() {
  return MilkRunV2Module;
}